import { FunctionComponent } from 'preact';
import { Image } from '@accedo/ctv-image';
import { stylesheet } from 'astroturf';
import clsx from 'clsx';

const styles = stylesheet`
  @import '##/styles/import.scss';

  .powered-by-logo {
    position: absolute;
    margin-left: pxToVw(6);
    height: pxToVh(28);
    width: auto;
    max-width: pxToVw(400);
  }
`;

const is720p = (): boolean => window.innerWidth <= 1280;

const PoweredByBranding: FunctionComponent<{
  logoClassName?: string;
  logoUrl: string;
}> = ({ logoClassName, logoUrl }) => (
  <>
    <Image
      className={clsx(styles.poweredByLogo, logoClassName)}
      url={`${logoUrl}${is720p() ? '?image-profile=livetv_branding' : ''}`}
    />
  </>
);

export { PoweredByBranding };
